<div fxLayout='row' fxLayoutAlign="center center">
  <main fxLayout='column' fxLayoutAlign="center center">

    <!-- **** BOUTONS NOUVEAU QUIZ / SAUVEGARDER **** -->

    <div>
      <button disabled class="card-button" mat-flat-button color="accent" (click)="applyToAllGroup()">{{'applyToAll' | translation}}</button>
    </div>

    <div id="headerText">
      <p class="main-title">{{'customQuizTitle' | translation}}</p>
      <p class="main-subtitle">{{'manageQuiz' |translation}}</p>
    </div>

    <header fxLayout="column" fxLayoutAlign="center center">


      <section fxLayout="row" fxLayoutAlign="space-between center">

        <button id="btnAddQuestion" mat-raised-button color="accent" (click)="createQuiz()">
          <mat-icon>add</mat-icon>
          {{'newQuiz' |translation}}
        </button>

      </section>


      <section fxLayout="column" fxLayoutAlign="space-between center">
        <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" (change)="activeRules($event.checked)" [(ngModel)]="enableRules">
          {{'enableRules' | translation}}
        </mat-slide-toggle>

        <ng-container *ngIf="enableRules">
          <div class="form-group" id="formImageUpload">

            <button mat-raised-button color="accent" id="uploadRules" (click)="onUploadImage()">
              <i class="material-icons">
                cloud_upload
              </i> {{'importRules' | translation}}
            </button>

            <input style="display: none;" mat-raised-button type="file" class="form-control"
                   (change)="uploadFiles($event, 'quiz/rules')" id="rules" name="rules">
          </div>

          <div class="backgroundsContainer">

            <div class="imgContainer">
              <img [src]="rulesURL" poster="" />
            </div>

          </div>

        </ng-container>


      </section>
    </header>

    <!-- **** LISTE DES QUIZ **** -->
    <div *ngIf="listQuiz != undefined" fxLayout="row" fxLayoutAlign="center flex-start"
         style="margin-top:20px; flex-wrap: wrap;" id="quizElementsWrapper">
      <mat-list>
        <mat-list-item *ngFor="let quiz of listQuiz.data; let i = index">
          <div class="matItemContainer">

            <div class="listIconElement">


              <mat-icon>
                question_answer
              </mat-icon>

            </div>
            <div class="listItemElement">
              <h4 mat-line>{{quiz.name}}</h4>

              <div class="interactElement">
                <div class="activated" *ngIf="activeQuiz == listQuiz.id[i]">
                  <mat-icon color="accent">check</mat-icon>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuQuizOptions">
                  <mat-icon>
                    more_vert
                  </mat-icon>
                </button>
              </div>
              <mat-divider [inset]="true"></mat-divider>
            </div>
          </div>
          <mat-menu #menuQuizOptions="matMenu">
            <button mat-menu-item (click)="getQuizData(listQuiz.id[i])">{{'edit' | translation}}</button>
            <button mat-menu-item (click)="setActiveQuiz(listQuiz.id[i])">{{'activate' | translation}}</button>
            <ng-container *ngIf="user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1' || user.uid == 'Vek8nznrSeOwIlBNgFC0pDXPt8s1'">


              <button mat-menu-item (click)="duplicateQuiz(i)">{{'duplicate' | translation}}</button>
            </ng-container>
            <button mat-menu-item (click)="removeQuiz(listQuiz.id[i])">{{'delete' |translation}}</button>
            <button mat-menu-item (click)="renameQuiz(listQuiz.id[i])">{{'rename' |translation}}</button>
          </mat-menu>

        </mat-list-item>
      </mat-list>
    </div>

    <!-- **** PARAMETRE D'UN QUIZ **** -->
    <div *ngIf="selectedQuiz != undefined && selectedQuiz.length > 0" fxLayout="column" fxLayoutAlign="center center"
         style="width:90%">

      <button id="scrollToEnd" (click)="scrollToEndPage()">
        <i class="material-icons">
          arrow_downward
        </i>
      </button>


      <div class="card" fxLayout="row" fxLayoutAlign="flex-start flex-start">
        <section class="card-section">
          <p class="card-title">{{'welcomeText' | translation}}</p>
          <p class="card-data">{{quizData.startText}}</p>
          <button class="card-button" mat-flat-button color="primary"
                  (click)="showModal('welcomeText', quizData.startText)">
            {{'changeText' | translation}}
          </button>



          <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
            <h2>{{'background' | translation}}</h2>

            <!--   <span class="spinner">
              <mat-spinner [diameter]="36"></mat-spinner>
            </span>-->


            <div class="empty-image-bg">
              <ng-container *ngIf="quizData.welcomeBackground">
                <img id="thumbnail" #thumbnail [hidden]="quizData.welcomeBackground.url == undefined || quizData.welcomeBackground.url.length == 0" [src]="quizData.welcomeBackground.url ||''" alt="Aucune image" />
              </ng-container>

            </div>
            <span class="logoButtonContainer" fxLayout="row">
              <button (click)="uploadElement(quizData.welcomeBackground, 'backgroundSettingsWelcome')" mat-mini-fab>
                <mat-icon>edit</mat-icon>
              </button>
              <button (click)="deleteQuizSettingsBackgroundElement(quizData.welcomeBackground)" style="{z-index: 1;}" mat-mini-fab
                      color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>

          <div *ngIf="isAvailable">
            <p class="card-title">{{'textPosition' | translation}} (Média 1.19.1+)</p>
            <mat-form-field>
              <mat-select [(ngModel)]="quizData.startTextPosition" (ngModelChange)="saveQuiz()">
                <mat-option value="high">{{'high' |translation}}</mat-option>
                <mat-option value="center">{{'center' |translation}}</mat-option>
                <mat-option value="low">{{'low' |translation}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>








        </section>
        <div class="divider"> </div>
        <section class="card-section">
          <p class="card-title">{{'thanksText' | translation }}</p>
          <p class="card-data">{{quizData.endText}}</p>
          <button class="card-button" mat-flat-button color="primary"
                  (click)="showModal('goodByeText', quizData.endText)">
            {{'changeText' | translation}}
          </button>

          <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
            <h2>{{'background' | translation}}</h2>

            <!-- <span class="spinner">
              <mat-spinner [diameter]="36"></mat-spinner>
            </span>-->


            <div class="empty-image-bg">
              <ng-container *ngIf="quizData.thanksBackground">
                <img id="thumbnail" #thumbnail [hidden]="quizData.thanksBackground.url == undefined || !quizData.thanksBackground.url || quizData.thanksBackground.url.length == 0" [src]="quizData.thanksBackground.url ||''" alt="Aucune image" />
              </ng-container>

            </div>
            <span class="logoButtonContainer" fxLayout="row">
              <button (click)="uploadElement(quizData.thanksBackground, 'backgroundSettingsThanks')" mat-mini-fab>
                <mat-icon>edit</mat-icon>
              </button>
              <button (click)="deleteQuizSettingsBackgroundElement(quizData.thanksBackground)" style="{z-index: 1;}" mat-mini-fab
                      color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          </div>
          <div *ngIf="isAvailable">
            <p class="card-title">{{'textPosition' | translation}} (Média 1.19.1+)</p>
            <mat-form-field>
              <mat-select [(ngModel)]="quizData.endTextPosition" (ngModelChange)="saveQuiz()">
                <mat-option value="high">{{'high' |translation}}</mat-option>
                <mat-option value="center">{{'center' |translation}}</mat-option>
                <mat-option value="low">{{'low' |translation}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </section>
        <div class="divider"> </div>
        <section class="card-section">

          <div>
            <p class="card-title">{{'backgroundColor' | translation}}</p>
            <div class="color-thumb" [style.background]='quizData.colorBackground'></div>
            <button class="card-button" mat-flat-button color="primary"
                    (click)="showColorModal(quizData.colorBackground, 'background')">
              {{'changeColor' | translation}}
            </button>
          </div>
          <div>
            <p class="card-title">{{'fontColor' | translation}}</p>
            <div class="color-thumb" [style.background]='quizData.colorText'></div>
            <button class="card-button" mat-flat-button color="primary"
                    (click)="showColorModal(quizData.colorText, 'text')">
              {{'changeColor' | translation}}
            </button>
          </div>
          <div *ngIf="sharedService.selectedDevice.data.modules.media">
            <p class="card-title">{{'fontColorButton' | translation}} (Média 1.17.20)</p>
            <div class="color-thumb" [style.background]='quizData.colorTextButton'></div>
            <button class="card-button" mat-flat-button color="primary"
                    (click)="showColorModal(quizData.colorTextButton, 'textButton')">
              {{'changeColor' | translation}}
            </button>
          </div>
          <div>
            <p class="card-title">{{'buttonColor' | translation}}</p>
            <div class="color-thumb" [style.background]='quizData.colorButton'></div>
            <button class="card-button" mat-flat-button color="primary"
                    (click)="showColorModal(quizData.colorButton, 'button')">
              {{'changeColor' | translation}}
            </button>
          </div>
        </section>


        <section class="card-section" *ngIf="sharedService.selectedDevice.data.modules.media">
          <h2>{{'annexoption' | translation}} (Media v1.17.10)</h2>

          <div *ngIf="sharedService.checkAppVersion('1.21.10', 'media')">
            <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="randomizeQuestion" [(ngModel)]="quizData.randomizeQuestion" (change)="updateQuizState()">{{'randomizeQuestion' | translation}}</mat-slide-toggle>
          </div>
          <div *ngIf="quizData.randomizeQuestion">
            <p></p>
            <mat-form-field autocomplete="off">
              <input matInput placeholder="Limite du nombre de quesitons" type="number" (change)="updateQuizState()"
                     [(ngModel)]="quizData.nbLimitQuestion" name="text">
            </mat-form-field>
          </div>


          <div>
            <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="enableEmail" [(ngModel)]="quizData.enableEmail">{{'enableEmail' | translation}}</mat-slide-toggle>
          </div>
          <ng-container *ngIf="quizData.enableEmail">
            <div>


              <mat-form-field class="addEmailInputElement example-full-width">
                <mat-label>{{'email' | translation}}</mat-label>
                <input #addEmailInput matInput placeholder="">
              </mat-form-field>
              <button mat-raised-button color="accent" (click)="addEmail(addEmailInput.value)"><mat-icon>add</mat-icon></button>
            </div>
            <div class="emailContainer">
              <div class="emailItem" *ngFor="let item of quizData.emailList; let i = index">
                <div>
                  <p>{{item}}</p>
                </div>
                <div>
                  <button mat-raised-button color="accent" (click)="deleteEmailFromList(i)"><mat-icon>delete</mat-icon></button>
                </div>
              </div>
            </div>

          </ng-container>
        </section>

      </div>



      <div class="card score" fxLayout="column" fxLayoutAlign="flex-start flex-start">

        <div>
          <p class="card-title score-title">{{'scoreManagement' | translation}}</p>

          <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="correctAnswer" [(ngModel)]="quizData.activeScore"
                            (change)="updateQuizState()">{{'activeScore' | translation}}</mat-slide-toggle>




        </div>


        <ng-container *ngIf="quizData.activeScore">

          <div class="scorenumber-wrapper" fxLayout="column">
            <div fxLayout="row">
              <mat-form-field>
                <mat-label>{{'scorePointDescription' | translation}}</mat-label>
                <input matInput name="questionPoint"
                       [(ngModel)]="quizData.questionPoint"
                       (blur)="saveQuiz()"
                       type="number" />
              </mat-form-field>
            </div>

          </div>
        </ng-container>

        <div *ngIf="quizData.activeScore">
          <button id="btnAddQuestion" mat-raised-button color="accent" (click)="addEndMessage(quizData)">
            <mat-icon>add</mat-icon>
            {{'addMsg' | translation}}
          </button>



          <ng-container *ngFor="let item of quizData.endMessages; let i = index">
            <p class="minmax-title">{{'msg' | translation}} n°{{i+1}}</p>

            <div fxLayout="column">
              <div class="minmax-wrapper" fxLayout="row">
                <mat-form-field>
                  <mat-label>Score min.</mat-label>
                  <input *ngIf="quizData.endMessages.length <= 1" matInput name="min" (blur)="checkEndMessageValue(item.min, item, 'min', $event.target.value)"
                         [(ngModel)]="item.min"
                         type="number" />
                  <input *ngIf="quizData.endMessages.length > 1" disabled matInput name="min" (blur)="checkEndMessageValue(item.min, item, 'min', $event.target.value)"
                         [(ngModel)]="item.min"
                         type="number" />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Score max.</mat-label>
                  <input matInput name="max" (blur)="checkEndMessageValue(item.max, item, 'max', $event.target.value)"
                         [(ngModel)]="item.max"
                         type="number" />
                </mat-form-field>
              </div>

              <div class="score-text">
                <mat-form-field>
                  <mat-label>{{'text' | translation}}</mat-label>
                  <textarea matInput class="endMessage" (change)="saveQuiz()" [(ngModel)]="item.message" type="text"></textarea>
                </mat-form-field>
              </div>

              <button (click)="removeEndMessageElement(quizData, i)" style="z-index: 1;" mat-mini-fab color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>

            <mat-divider></mat-divider>
          </ng-container>


        </div>
      </div>

      <div class="card quizQuestion" #addQuestionContainer>
        <h2>{{'addQuestion' |translation}}</h2>
        <h3>{{'addQuestionSub' | translation}}</h3>
        <span>{{'addQuestionExplanation' | translation}}</span>
        <div *ngFor="let type of questionType" class="addQuestionElement">
          <span>{{type.name | translation}}</span>
          <button mat-raised-button color="accent" (click)="addQuestion(type.key)">
            <mat-icon>add</mat-icon>
          </button>

        </div>
      </div>

      <!-- **** BOUTON AJOUTER UNE QUESTION **** -->
   <!--    <button id="btnAddQuestion" mat-raised-button color="accent" [matMenuTriggerFor]="menuAddQuestions">
          <mat-icon>add</mat-icon>
          {{'addQuestion' | translation}}
        </button>
        <mat-menu #menuAddQuestions="matMenu">
          <button mat-menu-item (click)="addQuestion('textfield')">Champ texte</button>
          <button mat-menu-item (click)="addQuestion('qcm')">QCM</button>

          <ng-container *ngIf="user.uid == '9lOKnEVpClcxibWJsORtzKQLbHt2' || isDev || user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1'">
            <button mat-menu-item (click)="addQuestion('signature')">Signature</button>
            <button mat-menu-item (click)="addQuestion('list')">Liste</button>
          </ng-container>
        </mat-menu>-->
      <!-- **** QUIZ DATAS **** -->

      <mat-accordion #allQuizAccordion
                     id="quizDatasWrapper"
                     cdkDropList
                     (cdkDropListDropped)="drop($event)">
        <mat-expansion-panel *ngFor="let item of questionList.id; let i = index"
                             cdkDrag
                             #panels
                             class="quizDatasCard"
                             [id]="'question-'+i"
                             (opened)="setOpenedQuestionId(item)"
                             [expanded]="item === openedQuestionId"
                             [attr.data-questionID]="item">

          <mat-expansion-panel-header>
            <mat-panel-title>
            <!--  <div class="cdk-handle-icon" cdkDragHandle (click)="$event.stopPropagation()">
                <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </div>-->

              {{'question' | translation}} n°{{i + 1}}

            </mat-panel-title>
            <mat-panel-description>
              {{questionList.data[i].label}}
            </mat-panel-description>
            <mat-action-row (click)="$event.stopPropagation()">
              <button mat-mini-fab color="warn" (click)="removeQuestion(item)">
                <mat-icon>delete</mat-icon>
              </button>
            </mat-action-row>
          </mat-expansion-panel-header>
          <mat-card-header class="questionCardHeader">

            <mat-card-subtitle *ngIf="questionList.data[i].type == 'textfield'">{{'textField' | translation}}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="questionList.data[i].type == 'qcm'">{{'qcm' | translation}}</mat-card-subtitle>


            <mat-card-subtitle *ngIf="questionList.data[i].type == 'signature'">{{'signature' | translation}}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="questionList.data[i].type == 'list'">{{'list' | translation}}</mat-card-subtitle>

            <mat-card-subtitle>Index</mat-card-subtitle>
          </mat-card-header>


          <mat-card-content *ngIf="questionList.data[i].type == 'textfield'">
            <div class="questionLine">

              <mat-form-field class="form-group" autocomplete="off">
                <input matInput placeholder="{{'questionTitle' | translation}}" (change)="saveQuiz()" type="text" matInput
                       [(ngModel)]="questionList.data[i].label" name="text">
              </mat-form-field>
              <div class="questionIndex">
                <mat-form-field class="order-select" appearance="fill">

                  <mat-label>{{questionList.data[i].priority}}</mat-label>
                  <mat-select (selectionChange)="changePriority(questionList.data[i].priority, $event.value, $event)">
                    <mat-option *ngFor="let i of questionList.data; let j = index;" [value]="i.priority">
                      {{i.priority}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div><div class="slidersContainer">
              <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="fieldRequired"
                                [(ngModel)]="questionList.data[i].required" (change)="saveQuiz()">{{'reqField' | translation}}</mat-slide-toggle>

              <ng-container *ngIf="user.uid == '9lOKnEVpClcxibWJsORtzKQLbHt2' || isDev || user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1' || user.uid == '1EljyUzx1AN6Vj4EMtKw2WIqg4o2'">

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="saveLocally"
                                  [(ngModel)]="questionList.data[i].saveLocally" (change)="saveQuiz()">{{'saveLocally' | translation}}</mat-slide-toggle>

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="skipNextQuestion"
                                  [(ngModel)]="questionList.data[i].skipNextQuestion" (change)="saveQuiz()">{{'skipNextQuestion' | translation}}</mat-slide-toggle>
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="addToEmail"
                                  [(ngModel)]="questionList.data[i].addToEmail" (change)="saveQuiz()">{{'addToEmail' | translation}}</mat-slide-toggle>

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endQuiz"
                                  [(ngModel)]="questionList.data[i].endQuiz" (change)="saveQuiz()">{{'endQuiz' | translation}}</mat-slide-toggle>

              </ng-container>
            </div>
            <mat-form-field id="inputTypeDeVerif">
              <mat-label>{{'verifType' | translation}}</mat-label>
              <mat-select (selectionChange)="selectChange(questionList.data[i], $event)   "
                          [(ngModel)]="questionList.data[i].validation">
                <mat-option value=" ">
                  {{'none' | translation}}
                </mat-option>
                <mat-option value="email">
                  {{'email' | translation}}
                </mat-option>
                <mat-option value="telephone">
                  {{'phoneNumber' | translation}}
                </mat-option>
                <mat-option value="code_postal">
                  {{'zipCode' | translation}}
                </mat-option>
                <mat-option value="date">
                  {{'date' | translation}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
              <h2>{{'background' | translation}}</h2>

              <span class="spinner">
                <mat-spinner [diameter]="36"></mat-spinner>
              </span>


              <div class="empty-image-bg">
                <img id="thumbnail" #thumbnail [hidden]="questionList.data[i].urlBackground == undefined" [src]="questionList.data[i].urlBackground" alt="Aucune image" />
              </div>
              <span class="logoButtonContainer" fxLayout="row">
                <button (click)="uploadElement(questionList.data[i], 'background')" mat-mini-fab>
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteQuizBackgroundElement(questionList.data[i])" style="{z-index: 1;}" mat-mini-fab
                        color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>


            <div *ngIf="isAvailable" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
              <h2>{{'media' | translation}}</h2>

              <span class="spinner">
                <mat-spinner [diameter]="36"></mat-spinner>
              </span>


              <div class="empty-image-bg">
                <img id="thumbnail" #thumbnail [hidden]="questionList.data[i].urlMedia == undefined" [src]="questionList.data[i].urlMedia" alt="Aucune image" />
              </div>
              <span class="logoButtonContainer" fxLayout="row">
                <button (click)="uploadElement(questionList.data[i], 'media')" mat-mini-fab>
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteQuizMediaElement(questionList.data[i])" style="{z-index: 1;}" mat-mini-fab
                        color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>
          </mat-card-content>

          <mat-card-content *ngIf="questionList.data[i].type == 'signature'">
            <div class="questionLine">

              <mat-form-field class="form-group" autocomplete="off">
                <input matInput placeholder="{{'questionTitle' | translation}}" (change)="saveQuiz()" type="text" matInput
                       [(ngModel)]="questionList.data[i].label" name="text">
              </mat-form-field>
              <div class="questionIndex">
                <mat-form-field class="order-select" appearance="fill">

                  <mat-label>{{questionList.data[i].priority}}</mat-label>
                  <mat-select (selectionChange)="changePriority(questionList.data[i].priority, $event.value, $event)">
                    <mat-option *ngFor="let i of questionList.data; let j = index;" [value]="i.priority">
                      {{i.priority}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="slidersContainer">
              <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="fieldRequired"
                                [(ngModel)]="questionList.data[i].required" (change)="saveQuiz()">{{'reqField' | translation}}</mat-slide-toggle>

              <!-- CUSTOM ELEMENT -->
              <ng-container *ngIf="user.uid == '9lOKnEVpClcxibWJsORtzKQLbHt2' || isDev || user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1' || user.uid == '1EljyUzx1AN6Vj4EMtKw2WIqg4o2'">
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="skipNextQuestion"
                                  [(ngModel)]="questionList.data[i].skipNextQuestion" (change)="saveQuiz()">{{'skipNextQuestion' | translation}}</mat-slide-toggle>
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endQuiz"
                                  [(ngModel)]="questionList.data[i].endQuiz" (change)="saveQuiz()">{{'endQuiz' | translation}}</mat-slide-toggle>



              </ng-container>
            </div>
            <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
              <h2>{{'background' | translation}}</h2>

              <span class="spinner">
                <mat-spinner [diameter]="36"></mat-spinner>
              </span>


              <div class="empty-image-bg">
                <img id="thumbnail" #thumbnail [hidden]="questionList.data[i].urlBackground == undefined" [src]="questionList.data[i].urlBackground" alt="Aucune image" />
              </div>
              <span class="logoButtonContainer" fxLayout="row">
                <button (click)="uploadElement(questionList.data[i], 'background')" mat-mini-fab>
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteQuizBackgroundElement(questionList.data[i])" style="{z-index: 1;}" mat-mini-fab
                        color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>

          </mat-card-content>

          <mat-card-content *ngIf="questionList.data[i].type == 'list'">
            <div class="questionLine">

              <mat-form-field class="form-group" autocomplete="off">
                <input matInput placeholder="{{'questionTitle' | translation}}" (change)="saveQuiz()" type="text" matInput
                       [(ngModel)]="questionList.data[i].label" name="text">
              </mat-form-field>
              <div class="questionIndex">
                <mat-form-field class="order-select" appearance="fill">

                  <mat-label>{{questionList.data[i].priority}}</mat-label>
                  <mat-select (selectionChange)="changePriority(questionList.data[i].priority, $event.value, $event)">
                    <mat-option *ngFor="let i of questionList.data; let j = index;" [value]="i.priority">
                      {{i.priority}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="slidersContainer">
              <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="fieldRequired"
                                [(ngModel)]="questionList.data[i].required" (change)="saveQuiz()">{{'reqField' | translation}}</mat-slide-toggle>
              <!-- CUSTOM ELEMENT -->
              <ng-container *ngIf="user.uid == '9lOKnEVpClcxibWJsORtzKQLbHt2' || isDev || user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1'">
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="skipNextQuestion"
                                  [(ngModel)]="questionList.data[i].skipNextQuestion" (change)="saveQuiz()">{{'skipNextQuestion' | translation}}</mat-slide-toggle>




                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endQuiz"
                                  [(ngModel)]="questionList.data[i].endQuiz" (change)="saveQuiz()">{{'endQuiz' | translation}}</mat-slide-toggle>
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="localList"
                                  [(ngModel)]="questionList.data[i].localList" (change)="saveQuiz()">{{'localist' | translation}}</mat-slide-toggle>

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="addToEmail"
                                  [(ngModel)]="questionList.data[i].addToEmail" (change)="saveQuiz()">{{'addToEmail' | translation}}</mat-slide-toggle>

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="useAsEmail"
                                  [(ngModel)]="questionList.data[i].useAsEmail" (change)="saveQuiz()">{{'useAsEmail' | translation}}</mat-slide-toggle>

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="allowNewListEntry"
                                  [(ngModel)]="questionList.data[i].allowNewListEntry" (change)="saveQuiz()">{{'allowNewListEntry' | translation}}</mat-slide-toggle>
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="allowDeleteListEntry"
                                  [(ngModel)]="questionList.data[i].allowDeleteListEntry" (change)="saveQuiz()">{{'allowDeleteListEntry' | translation}}</mat-slide-toggle>


                <!-- LIST ADD/REMOVE ELEMENT -->


                <mat-accordion>
                  <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <p>Éléments de la liste</p>
                      </mat-panel-title>
                      <mat-panel-description>
                        <p>Cliquer pour modifier le contenu de la liste</p>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div>
                      <div>
                        <mat-form-field class="addEmailInputElement example-full-width">
                          <mat-label>{{'itemList' | translation}}</mat-label>
                          <input #addListItemInput matInput placeholder="">
                        </mat-form-field>
                        <button mat-raised-button color="accent" (click)="addListItem(addListItemInput.value, i); addListItemInput.value = ''"><mat-icon>add</mat-icon></button>
                      </div>
                      <ng-container *ngFor="let item of questionList.data[i].listItems; let indexI = index">
                        <div class="listItems">
                          <p>{{item}}</p>
                          <div class="buttonEmailContainer">
                            <button mat-raised-button color="accent" (click)="updateItemFromList(i, indexI)"><mat-icon>cached</mat-icon></button>

                            <button mat-raised-button color="warn" (click)="deleteItemFromList(i, indexI)"><mat-icon>delete</mat-icon></button>
                          </div>
                        </div>
                      </ng-container>


                    </div>
                  </mat-expansion-panel>
                </mat-accordion>

              </ng-container>
            </div>
            <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
              <h2>{{'background' | translation}}</h2>

              <span class="spinner">
                <mat-spinner [diameter]="36"></mat-spinner>
              </span>


              <div class="empty-image-bg">
                <img id="thumbnail" #thumbnail [hidden]="questionList.data[i].urlBackground == undefined" [src]="questionList.data[i].urlBackground" alt="Aucune image" />
              </div>
              <span class="logoButtonContainer" fxLayout="row">
                <button (click)="uploadElement(questionList.data[i], 'background')" mat-mini-fab>
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteQuizBackgroundElement(questionList.data[i])" style="{z-index: 1;}" mat-mini-fab
                        color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>


          </mat-card-content>

          <mat-card-content *ngIf="questionList.data[i].type == 'qcm'">
            <div class="questionLine">

              <mat-form-field class="form-group" autocomplete="off">
                <input matInput placeholder="{{'questionTitle' | translation}}" type="text" (change)="saveQuiz()" matInput
                       [(ngModel)]="questionList.data[i].label" name="text">
              </mat-form-field>
              <div class="questionIndex">
                <mat-form-field class="order-select" appearance="fill">

                  <mat-label>{{questionList.data[i].priority}}</mat-label>
                  <mat-select (selectionChange)="changePriority(questionList.data[i].priority, $event.value, $event)">
                    <mat-option *ngFor="let i of questionList.data; let j = index;" [value]="i.priority">
                      {{i.priority}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="true-false-message-wrapper" *ngIf="quizData.activeScore">
              <div>

                <mat-form-field>
                  <mat-label>{{'correctAnswerMessage' | translation}}</mat-label>
                  <input matInput (change)="saveQuiz()" type="text" matInput
                         [(ngModel)]="questionList.data[i].correctMessage" name="text">
                </mat-form-field>
              </div>
              <div>
                <div>

                  <mat-form-field>
                    <mat-label>{{'wrongAnswerMessage' | translation}}</mat-label>
                    <input matInput (change)="saveQuiz()" type="text" matInput
                           [(ngModel)]="questionList.data[i].wrongMessage" name="text">
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="slidersContainer">


              <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endTextQuestionElement" (change)="saveQuiz()"
                                [(ngModel)]="questionList.data[i].enableEndTextQuestion">{{'endTextQuestion' | translation}}  (Média 1.18.0)</mat-slide-toggle>
              <div *ngIf="questionList.data[i].enableEndTextQuestion" class="endTextQuestionTextAreaContainer">
                <mat-form-field class="textAreaEndTextQuestion">
                  <mat-label>{{'endTextQuestionLabel' | translation}}</mat-label>
                  <textarea matInput placeholder="" [(ngModel)]="questionList.data[i].endTextQuestionLabel" (change)="saveQuiz()"></textarea>
                </mat-form-field>
              </div>
              <mat-slide-toggle [labelPosition]="'before'" *ngIf="sharedService.checkAppVersion('1.21.37','media')" color="accent" type="checkbox" name="endTextQuestionElement" (change)="saveQuiz()"
                                [(ngModel)]="questionList.data[i].sendEmailToResponse.enable">{{'sendEmailToResponse' | translation}}  (Média 1.21.37)</mat-slide-toggle>


              <ng-container *ngIf="questionList.data[i].sendEmailToResponse.enable">
                <mat-form-field class="textAreaEndTextQuestion">
                  <mat-label>{{'emailObject' | translation}}</mat-label>
                  <input matInput placeholder="" [(ngModel)]="questionList.data[i].sendEmailToResponse.object" (change)="saveQuiz()" />
                </mat-form-field>
                <mat-form-field class="textAreaEndTextQuestion">
                  <mat-label>{{'emailContent' | translation}}</mat-label>
                  <textarea matInput placeholder="" [(ngModel)]="questionList.data[i].sendEmailToResponse.content" (change)="saveQuiz()"></textarea>
                </mat-form-field>

              </ng-container>


              <ng-container *ngIf="user.uid == '9lOKnEVpClcxibWJsORtzKQLbHt2' || isDev || user.uid == 'TW0LZKlTEkPeU2up4L462QVlWtk1' || user.uid == '1EljyUzx1AN6Vj4EMtKw2WIqg4o2' || user.uid == 'p9YDZYevZ7VGgIiBo0zJbzHrGar2'">

                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="skipNextQuestion"
                                  [(ngModel)]="questionList.data[i].skipNextQuestion" (change)="saveQuiz()">{{'skipNextQuestion' | translation}}</mat-slide-toggle>
                <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endQuiz"
                                  [(ngModel)]="questionList.data[i].endQuiz" (change)="saveQuiz()">{{'endQuiz' | translation}}</mat-slide-toggle>
              </ng-container>

              <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="qcmRequired" (change)="saveQuiz()"
                                [(ngModel)]="questionList.data[i].required">{{'reqResp' | translation}}</mat-slide-toggle>
              <mat-slide-toggle [labelPosition]="'before'" *ngIf="listModules.media" color="accent" type="checkbox" name="displayLabel" (change)="saveQuiz()"
                                [(ngModel)]="questionList.data[i].displayLabel">{{'displayLabel' | translation}}</mat-slide-toggle>
              <mat-slide-toggle [labelPosition]="'before'" *ngIf="listModules.media" color="accent" type="checkbox" name="enableMultipleResponse" (change)="saveQuiz()"
                                [(ngModel)]="questionList.data[i].enableMultipleResponse">{{'enableMultipleResponse' | translation}}</mat-slide-toggle>
            </div>



            <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
              <h2>{{'background' | translation}}</h2>

              <span class="spinner">
                <mat-spinner [diameter]="36"></mat-spinner>
              </span>


              <div class="empty-image-bg">
                <img id="thumbnail" #thumbnail [hidden]="questionList.data[i].urlBackground == undefined" [src]="questionList.data[i].urlBackground" alt="Aucune image" />
              </div>
              <span class="logoButtonContainer" fxLayout="row">
                <button (click)="uploadElement(questionList.data[i], 'background')" mat-mini-fab>
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteQuizBackgroundElement(questionList.data[i])" style="{z-index: 1;}" mat-mini-fab
                        color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>

            <div fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
              <h2>{{'media' | translation}}</h2>

              <span class="spinner">
                <mat-spinner [diameter]="36"></mat-spinner>
              </span>


              <div class="empty-image-bg">
                <img id="thumbnail" #thumbnail [hidden]="questionList.data[i].urlMedia == undefined" [src]="questionList.data[i].urlMedia" alt="Aucune image" />
              </div>
              <span class="logoButtonContainer" fxLayout="row">
                <button (click)="uploadElement(questionList.data[i], 'media')" mat-mini-fab>
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteQuizMediaElement(questionList.data[i])" style="{z-index: 1;}" mat-mini-fab
                        color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </div>




            <!--   <mat-slide-toggle class="multiAnswersToggle" color="accent" type="checkbox" name="multipleAnswers"
                              (change)="saveQuiz()" [disabled]="quizData.activeScore" [(ngModel)]="questionList.data[i].multi">
              {{'multiResp' | translation}}
            </mat-slide-toggle>-->

            <button id="buttonAddAnswer" color="accent" mat-raised-button (click)="addResponse(item)">
              <mat-icon>add</mat-icon>
              {{'addResp' | translation}}
            </button>

            <!-- <button mat-mini-fab color="warn" (click)="removeQuestion(item)">
              <mat-icon>delete</mat-icon>
            </button>-->



            <div *ngFor="let response of questionList.data[i].response ; let iR = index" fxLayout="column"
                 fxLayoutAlign="center center" class="responseContainer">
              <mat-form-field class="form-group" autocomplete="off">
                <input matInput placeholder="{{'resp' | translation}} #{{iR + 1}}" type="text" (change)="saveQuiz()" matInput
                       [(ngModel)]="response.label" name="text">
              </mat-form-field>
              <div class="answersOptions">

                <div *ngIf="listModules.media" class="indicationContainer">
                  <span class="indicationText">{{'maxDimensionRespImage' | translation}}: 350px x 200px</span>
                  <span class="indicationText">Disponible dans la version 1.17.15 de l'application Média</span>
                </div>

                <div *ngIf="listModules.media" fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
                  <h2>{{'image' | translation}}</h2>

                  <span class="spinner">
                    <mat-spinner [diameter]="36"></mat-spinner>
                  </span>


                  <div class="empty-image-bg">
                    <img id="thumbnail" #thumbnail [hidden]="response.img && response.img.url == undefined" *ngIf="response.img && response.img.url" [src]="response.img.url" alt="Aucune image" />
                  </div>
                  <span class="logoButtonContainer" fxLayout="row">
                    <button (click)="uploadElement({'ques': questionList.data[i], respInd: iR}, 'response')" mat-mini-fab>
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button (click)="deleteQuizResponseMedia(questionList.data[i], iR)" style="{z-index: 1;}" mat-mini-fab
                            color="warn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </span>
                </div>


                <mat-form-field>
                  <mat-label>{{'condition' | translation}}</mat-label>
                  <mat-select (selectionChange)="saveQuiz()" [(ngModel)]="response.jump_to">
                    <mat-option [value]="null">
                      {{'none' | translation}}
                    </mat-option>
                    <mat-option *ngFor="let data of questionList.id; let qId = index" [value]="data">
                      {{questionList.data[qId].label.length != "" ? questionList.data[qId].label : data}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <div class="answer-actions slidersContainer">
                  <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="correctAnswer"
                                    [(ngModel)]="response.correct" (change)="setCorrectResponse(response, questionList.data[i].response, $event.checked)">{{'correctAnswer' | translation}}</mat-slide-toggle>


                  <ng-container *ngIf="user.uid == '1EljyUzx1AN6Vj4EMtKw2WIqg4o2' || isDev || user.uid == 'p9YDZYevZ7VGgIiBo0zJbzHrGar2' ">
                    <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endQuiz"
                                      [(ngModel)]="response.endQuiz" (change)="saveQuiz()">{{'endQuizResp' | translation}}</mat-slide-toggle>
                  </ng-container>

                  <ng-container *ngIf="sharedService.checkAppVersion('1.21.37', 'media')|| isDev">
                    <mat-slide-toggle [labelPosition]="'before'" color="accent" type="checkbox" name="endQuiz"
                                      [(ngModel)]="response.additionnalDisplay" (change)="saveQuiz()">{{'responseAdditionnalElement' | translation}}</mat-slide-toggle>
                    <ng-container *ngIf="response.additionnalDisplay">
                      <div>
                        <textarea matInput class="endMessage" (change)="saveQuiz()" [(ngModel)]="response.endMessage" type="text"></textarea>
                      </div>
                      <div>
                        <div fxLayout="column" fxLayoutAlign="flex-start center" class="image-upload-wrapper">
                          <h2>{{'background' | translation}}</h2>

                          <span class="spinner">
                            <mat-spinner [diameter]="36"></mat-spinner>
                          </span>
                          <div class="empty-image-bg">
                            <img id="thumbnail" #thumbnail [hidden]="response?.endUrlMedia == undefined" [src]="response.endUrlMedia?.url" alt="Aucune image" />
                          </div>
                          <span class="logoButtonContainer" fxLayout="row">
                            <button (click)="uploadElement({'ques': questionList.data[i], respInd: iR}, 'responseBackground')" mat-mini-fab>
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button (click)="deleteQuizResponseEndMedia(questionList.data[i], iR)" style="{z-index: 1;}" mat-mini-fab
                                    color="warn">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>

                </div>
                <button mat-mini-fab color="warn" (click)="removeResponse(i ,iR)">
                  <mat-icon>delete</mat-icon>
                </button>





              </div>
            </div>
          </mat-card-content>

          <mat-card-actions *ngIf="questionList.data[i].type == 'textfield'">



          </mat-card-actions>

          <mat-card-actions *ngIf="questionList.data[i].type == 'signature'">


            <!--      <button mat-mini-fab color="warn" (click)="removeQuestion(item)">
                    <mat-icon>delete</mat-icon>
                  </button>-->
          </mat-card-actions>

          <!-- QUESTION TYPE: LIST -->
          <mat-card-actions *ngIf="questionList.data[i].type == 'list'">



            <!--   <button mat-mini-fab color="warn" (click)="removeQuestion(item)">
                 <mat-icon>delete</mat-icon>
               </button>-->
          </mat-card-actions>

          <mat-card-actions *ngIf="questionList.data[i].type == 'qcm'">

          </mat-card-actions>



        </mat-expansion-panel>


      </mat-accordion>



    </div>
  </main>
</div>


<app-question-list *ngIf="questionList?.data?.length > 0" [questionList]="questionList" (expandQuestion)=" setOpenedQuestionId($event)" (listOrderUpdate)="questionList = $event; saveQuiz()" [openedQuestionId]="openedQuestionId"></app-question-list>

<app-floating-add-question *ngIf="showAddQuestionFloatingButton" [questionType]="questionType" (newQuestiontype)="addQuestion($event)"></app-floating-add-question>
